import React from "react";
import "./Kitchen.css";
import { useInView } from "react-intersection-observer";
import { Button } from "../../components/Button/Button";
import SEO from "../../components/SEO";

import heroImage from "../../images/morepics/420 ChapelWood Court - The View_001.jpg";
import image1 from "../../images/morepics/Zaid Joe - 3403 garden gate way rev 6-11-2023_011.jpg";
import image2 from "../../images/morepics/11419 ST GERMAIN WAY TOPO - The View 10-12-23_010.jpg";

export default function Kitchen() {
    const { ref: introRef, inView: introVisible } = useInView();
    const { ref: featureRef, inView: featureVisible } = useInView();

    return (
        <>
            <SEO
                title="Outdoor Kitchen Design | MICO Pool Design and Consulting"
                description="Design a custom outdoor kitchen with thoughtful cooking, prep, serving, lighting, and finish selections for your backyard."
            />
            <div
                className="kitchen"
                style={{ backgroundImage: `url(${heroImage})` }}
            >
                <h1 className="kitchen-header">OUTDOOR KITCHENS</h1>
            </div>

            <section className="kitchen-content">
                <div
                    className={
                        introVisible
                            ? "kitchen-left kitchen-left-move"
                            : "kitchen-left"
                    }
                    ref={introRef}
                >
                    <h2>Designed as an Extension of Your Home</h2>
                    <p>
                        Your outdoor kitchen should feel intentional, elevated,
                        and effortless to use. We design each layout to align
                        with your pool, patio flow, and entertaining style so
                        every element works together as one refined space.
                    </p>
                </div>
                <div className="kitchen-right-image-wrap">
                    <img
                        className="kitchen-image"
                        src={image1}
                        alt="Luxury outdoor kitchen and pool entertaining space"
                    />
                </div>
            </section>

            <section className="kitchen-feature-strip">
                <div>
                    <h3>Custom Layouts</h3>
                    <p>Built around your hosting flow and backyard architecture.</p>
                </div>
                <div>
                    <h3>Premium Finishes</h3>
                    <p>Stone, tile, and countertop selections curated for durability.</p>
                </div>
                <div>
                    <h3>Seamless Integration</h3>
                    <p>Coordinated with your pool design, lighting, and hardscape.</p>
                </div>
            </section>

            <section className="kitchen-content kitchen-content-reverse">
                <div className="kitchen-left-image-wrap">
                    <img
                        className="kitchen-image"
                        src={image2}
                        alt="Custom outdoor kitchen design connected to a modern backyard"
                    />
                </div>
                <div
                    className={
                        featureVisible
                            ? "kitchen-right kitchen-right-move"
                            : "kitchen-right"
                    }
                    ref={featureRef}
                >
                    <h2>What We Plan Into Every Kitchen</h2>
                    <ul className="kitchen-list">
                        <li>Dedicated prep, cooking, and serving zones</li>
                        <li>Storage solutions for clean, uncluttered surfaces</li>
                        <li>Ventilation and appliance placement for performance</li>
                        <li>Lighting plans for day-to-night usability</li>
                        <li>Material palettes matched to your full exterior concept</li>
                    </ul>
                    <div className="kitchen-cta">
                        <Button
                            buttonStyle="btn--outline"
                            buttonSize="btn--medium"
                            buttonLink="/contact"
                        >
                            Start Your Kitchen Design
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}
